<template>


   <span
       class="game"
       :class="[
           'game--'+snakeCase(bet.code),
           sizeClass,
           iconed ? 'game--iconed games__list__link' : '',
           active ? 'is-active' : '',
           isBooster ? 'game--boosted' : ''
       ]"
       :title="name_inner"
   >
      {{ bet.title ? bet.title : bet.code }}

      <span
          v-if="isBooster"
          class="game__tooltip">
          {{ bet.title ? bet.title : bet.code }}
         <br>
         Boost <span v-html="formatToMoney(bet.booster * 100, 0, true)"></span>
      </span>
   </span>
</template>

<script>
export default {
   name: "game",
   props: {
      bet: {
         type: Object
      },
      size:{
         type: String,
         default: null
      },
      iconed: {
         type: Boolean,
         default: true
      },
      active:{
         type: Boolean,
         default: false
      },
      noBooster:{
         type: Boolean,
         default: false
      }
   },
   computed:{
      sizeClass(){

         if(this.size){
            return 'game--iconed--'+this.size;
         }

         return '';
      },


      name_inner(){

         let guide = this.$store.state.once.betGuide.find(el=> el.name === this.bet.code);

         if(guide){
            return guide.title;
         }else{
            return this.bet.code;
         }
      },
      isBooster(){
         return !this.noBooster &&  this.bet.booster && !isNaN(this.bet.booster);
      }
   }
}
</script>

<style lang="scss">

</style>
